"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleChart = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledCircleChart = styled_components_1.default.div `
.pie {
    --p:${({ percentage }) => percentage};
    --b:6px;
    --c:${({ color }) => color};
    --w:150px;
    
    width: ${({ width }) => width}px;
    aspect-ratio:1;
    position:relative;
    display:inline-grid;
    margin:5px;
    place-content:center;
    font-size:25px;
    font-weight:bold;
    font-family:sans-serif;
  }
  .pie:before {
    content:"";
    position:absolute;
    border-radius:50%;
  }
  .pie:before {
    inset:0;
    background:
      conic-gradient(${({ color }) => color}70 calc(100 * 1%),#0000 0);
    -webkit-mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
            mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
  }
  .pie:after {
    content:"";
    position:absolute;
    border-radius:50%;
  }
  .pie:after {
    inset:0;
    background:
      conic-gradient(var(--c) calc(${({ percentage }) => percentage}*1%),#0000 0);
    -webkit-mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
            mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
  }
`;
const CircleChart = ({ percentage, width, color = "#8b0000" }) => {
    return (react_1.default.createElement(StyledCircleChart, { percentage: percentage, width: width, color: color },
        react_1.default.createElement("div", { className: "pie" },
            react_1.default.createElement("div", null,
                percentage,
                "%"))));
};
exports.CircleChart = CircleChart;
